// extracted by mini-css-extract-plugin
export default {"theme-switcher-btn":"ThemeSwitcher_theme-switcher-btn__n0tj3"};